import React, { FC } from 'react';
import { SessionDto } from '@services';
import styles from './SessionTitleComponent.module.scss';

interface SessionTitleComponentProps {
    session: SessionDto;
}

const SessionTitleComponent: FC<SessionTitleComponentProps> = (props) => {
    const { session } = props;

    return (
        <span className={styles.SessionTitleComponent} data-testid="SessionTitleComponent">
            {session.title ? session.title : 'Unnamed'}
        </span>
    );
};

export default SessionTitleComponent;
